var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.349,
    height: 13.456,
    viewBox: "0 0 26.349 13.456",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4c29e82442d2137fed9e8f7a35a474d7",
    "data-name": "4c29e82442d2137fed9e8f7a35a474d7",
    transform: "translate(-10.001 -249.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65326",
    "data-name": "Path 65326",
    d: "M106.2,611.688a1.888,1.888,0,1,0,3.775,0h0a1.888,1.888,0,0,0-3.775,0Z",
    transform: "translate(-93.612 -350.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65327",
    "data-name": "Path 65327",
    d: "M754.7,611.688a1.888,1.888,0,1,0,1.888-1.888,1.887,1.887,0,0,0-1.888,1.888Z",
    transform: "translate(-724.675 -350.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65328",
    "data-name": "Path 65328",
    d: "M34.771,249.8H13.265a2.444,2.444,0,0,0-2.342,1.748,27.9,27.9,0,0,0-.836,9.675,1.051,1.051,0,0,0,1.051.984H12a2.618,2.618,0,1,1,5.093-.852,2.567,2.567,0,0,1-.145.852H29.42a2.619,2.619,0,1,1,4.948,0H35.3a1.056,1.056,0,0,0,1.054-1.054v-9.772A1.576,1.576,0,0,0,34.771,249.8Zm-18.446,5.719-1.546,1.172H11.168a21.908,21.908,0,0,1,.812-4.832,1.346,1.346,0,0,1,1.285-.957h3.06v4.617Zm6.061-.2H17.379v-4.41h5.007v4.41Zm6.588,0H23.44v-4.41h5.534Zm6.276,0H30.028v-4.41h4.8a.421.421,0,0,1,.422.422Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusIcon);
export default __webpack_public_path__ + "static/media/Bus-Icon.2336e920f32a8716e6a31c8e92f3e386.svg";
export { ForwardRef as ReactComponent };